import React from 'react';
import { useTheme, AI_COLOR, AI_LIGHT } from '../../context/ThemeContext';

export const Pill = ({ c, bg, children }) => {
  const { B } = useTheme();
  const color = c || B.green;
  return (
    <span style={{
      fontSize: 10, fontWeight: 700, padding: '2px 8px', borderRadius: 20,
      background: bg || color + '18', color: color, lineHeight: 1.8, whiteSpace: 'nowrap'
    }}>{children}</span>
  );
};

export const AIBadge = ({ label = 'AI Generated' }) => (
  <span style={{
    display: 'inline-flex', alignItems: 'center', gap: 3, fontSize: 9, fontWeight: 700,
    padding: '2px 8px', borderRadius: 20, background: `linear-gradient(135deg,${AI_COLOR},#6d28d9)`,
    color: '#fff', letterSpacing: '0.04em', whiteSpace: 'nowrap'
  }}>⚡{label}</span>
);

export const Btn = ({ children, onClick, color, outline, small, style = {} }) => {
  const { B } = useTheme();
  const btnColor = color || B.navy;
  return (
    <button onClick={onClick} style={{
      fontFamily: 'inherit', fontSize: small ? 10 : 12, fontWeight: 700,
      padding: small ? '4px 10px' : '8px 16px', borderRadius: 8,
      border: `1.5px solid ${outline ? btnColor : 'transparent'}`,
      background: outline ? 'transparent' : btnColor,
      color: outline ? btnColor : '#fff', cursor: 'pointer', ...style
    }}>{children}</button>
  );
};

export const Divider = () => {
  const { B } = useTheme();
  return <div style={{ height: 1, background: B.border, margin: '14px 0' }} />;
};

export const Field = ({ label, value, ai }) => {
  const { B } = useTheme();
  return (
    <div style={{ marginBottom: 12 }}>
      <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: 3 }}>
        <label style={{ fontSize: 11, fontWeight: 600, color: B.text }}>{label}</label>
        {ai && <AIBadge label="AI" />}
      </div>
      <div style={{
        fontSize: 12, color: B.text, background: ai ? AI_LIGHT : B.inputBg,
        border: `1.5px solid ${ai ? AI_COLOR + '30' : B.inputBorder}`, borderRadius: 8, padding: '7px 10px'
      }}>{value || <span style={{ color: B.muted }}>—</span>}</div>
    </div>
  );
};

export const InputField = ({ label, placeholder, type = 'text', select, options = [], value, onChange }) => {
  const { B } = useTheme();
  return (
    <div style={{ marginBottom: 12 }}>
      {label && <label style={{ fontSize: 11, fontWeight: 600, color: B.text, display: 'block', marginBottom: 3 }}>{label}</label>}
      {select
        ? <select value={value} onChange={onChange} style={{
            width: '100%', fontSize: 12, padding: '7px 10px', borderRadius: 8,
            border: `1.5px solid ${B.inputBorder}`, fontFamily: 'inherit', color: B.text, background: B.inputBg, outline: 'none'
          }}>
            {options.map(o => <option key={o}>{o}</option>)}
          </select>
        : <input type={type} placeholder={placeholder} value={value} onChange={onChange} style={{
            width: '100%', fontSize: 12, padding: '7px 10px', borderRadius: 8,
            border: `1.5px solid ${B.inputBorder}`, fontFamily: 'inherit', color: B.text, background: B.inputBg, outline: 'none'
          }} />
      }
    </div>
  );
};

export const Card = ({ children, style = {} }) => {
  const { B } = useTheme();
  return (
    <div style={{
      background: B.cardBg, border: `1px solid ${B.border}`, borderRadius: 12, padding: 16, ...style
    }}>{children}</div>
  );
};

export const SectionTitle = ({ children, action }) => {
  const { B } = useTheme();
  return (
    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'space-between', marginBottom: 12, flexWrap: 'wrap', gap: 8 }}>
      <div style={{ fontSize: 13, fontWeight: 700, color: B.navy }}>{children}</div>
      {action}
    </div>
  );
};

export const TabBar = ({ tabs, activeTab, onTabChange }) => {
  const { B } = useTheme();
  return (
    <div style={{
      display: 'flex', gap: 4, marginBottom: 16, background: B.bg,
      borderRadius: 10, padding: 4, width: 'fit-content', flexWrap: 'wrap'
    }}>
      {tabs.map(([id, label]) => (
        <button key={id} onClick={() => onTabChange(id)} style={{
          fontFamily: 'inherit', fontSize: 11, fontWeight: 700, padding: '6px 14px', borderRadius: 8,
          border: 'none', cursor: 'pointer',
          background: activeTab === id ? B.cardBg : 'transparent',
          color: activeTab === id ? B.navy : B.muted,
          boxShadow: activeTab === id ? (B.isDarkMode ? '0 1px 4px rgba(0,0,0,0.2)' : '0 1px 4px rgba(0,0,0,0.08)') : 'none'
        }}>{label}</button>
      ))}
    </div>
  );
};